import { BaseModel } from 'sjs-base-model';

export class FilePathModel extends BaseModel {
	public name: string = '';
	public lastModified?: string = undefined;
	public size?: number = undefined;
	public allowDownload?: boolean = undefined;

	constructor(data: Partial<FilePathModel> | string = {}) {
		super();
		if (typeof data === 'string') {
			this.update({ name: data });
			return;
		}
		this.update({
			name: data.name ?? '',
			lastModified: data.lastModified,
			size: data.size,
			allowDownload: data.allowDownload,
		});
	}
}

export class FileModel extends FilePathModel {
	constructor(data: Partial<FileModel> = {}) {
		super(data);
	}
}



export  class FileDownloadModel extends BaseModel {
	public content : Blob = new Blob();
	public fileName?: string = undefined;

	constructor(data: Partial<FileDownloadModel>) {
		super();
		this.update({
			content: data.content as Blob,
			fileName: data.fileName,
		});
	}
}




